<template>
  <el-tooltip placement="top">
    <div slot="content">Фильтр по оператору, создавшему операцию</div>
    <el-select
      :value="value"
      value-key="_id"
      :placeholder="placeholder"
      clearable
      filterable
      :loading="loading"
      @change="onChange"
    >
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
  </el-tooltip>
</template>
<script>
import { queryUsers } from "@/api";

export default {
  name: "SelectUser",
  props: {
    level: {
      type: Array,
      default: () => [-1, 0, 1]
    },
    value: {
      type: String
    },
    placeholder: {
      type: String,
      default: "Пользователь"
    }
  },
  data() {
    return {
      selectedUser: null,
      rawOptions: [],
      loading: true
    };
  },
  computed: {
    options() {
      return this.rawOptions.map(option => {
        return {
          label: option.login,
          value: option._id
        };
      });
    }
  },
  methods: {
    onChange(val) {
      // this.$emit("change", val);
      this.$emit("input", val);
    }
  },
  async mounted() {
    this.loading = true;
    const res = await queryUsers({ type: { $in: this.level } });
    this.rawOptions = res.data.result;
    this.loading = false;
  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/ui/SelectUser.vue